<template>
  <div>
    <ContentWithImage src="page404" image-order="1" image-order-sm="1" margin="50px 0">
      <text-container>
        <h2 class="h1" v-html="$t(`page404.title`)"/>
        <p v-html="$t(`page404.text`)"/>
        <b-btn class="mt-2" variant="primary" to="/">
          {{$t(`page404.btn`)}}
        </b-btn>
      </text-container>
    </ContentWithImage>
    <div class="d-flex justify-content-end mb-5">
      <img src="@/assets/lotus.svg">
    </div>
  </div>
</template>

<script>
import { ContentWithImage } from '@/components/ui'

export default {
  name: 'Page404',
  components: { ContentWithImage }
}
</script>

<style lang="sass" scoped>
button
  min-width: 140px
</style>



// WEBPACK FOOTER //
// src/components/errors/Page404.vue